import React from 'react';
import cn from 'classnames';
import type { IconProps } from '../icon-prop-types';
import { IconSizes } from '../icon-prop-types';
import * as Styles from '../Icon.module.scss';

const TEST_ID = 'eye-filled-icon';

/**
 * An Icon whose SVG shows an open eye with a line through it
 * @param IconProps
 */
export const EyeFilled = ({ fill = 'black', size = 'xsmall' }: IconProps) => {
    const fillStyles = cn(Styles[fill], Styles.fill);
    const iconSize = IconSizes[size];
    return (
        <svg
            width={iconSize}
            height={iconSize}
            viewBox="0 -3 24 24"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            data-testid={TEST_ID}
        >
            <g className={fillStyles}>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M1.137.293a1 1 0 0 1 1.414 0l18 18a1 1 0 0 1-1.414 1.414l-3.154-3.154C14.54 17.4 12.816 18 10.844 18c-2.861 0-5.194-1.265-6.923-2.707-1.726-1.441-2.91-3.107-3.503-4.046l-.024-.038c-.117-.185-.27-.425-.347-.762a2.16 2.16 0 0 1 0-.894c.077-.337.23-.578.348-.764l.024-.038c.603-.953 1.826-2.676 3.62-4.141L1.138 1.707a1 1 0 0 1 0-1.414Zm6.261 7.675a4 4 0 0 0 5.478 5.478l-1.514-1.514a2 2 0 0 1-2.45-2.45L7.398 7.968Z"
                />
                <path d="M14.836 9.75a4 4 0 0 0-3.742-3.742L7.636 2.549A9.682 9.682 0 0 1 10.844 2c2.862 0 5.195 1.265 6.923 2.707 1.727 1.441 2.91 3.107 3.503 4.046l.024.038c.118.185.27.425.348.762a2.16 2.16 0 0 1 0 .894c-.078.337-.23.577-.348.762l-.024.038a18.405 18.405 0 0 1-2.158 2.778L14.836 9.75Z" />
            </g>
        </svg>
    );
};

EyeFilled.TEST_ID = TEST_ID;
